import React from 'react';
import './AuthNotification.css';

const AuthNotification = ({ show, onRefresh, onDismiss }) => {
  if (!show) return null;

  return (
    <div className="auth-notification-overlay" style={{ zIndex: 100000 }}>
      <div className="auth-notification-container">
        <div className="auth-notification-icon">⚠️</div>
        <div className="auth-notification-content">
          <h3>Session Expired!</h3>
          <p>Your login session has expired.<br />Please refresh the page and log in again to continue.</p>
        </div>
        <div className="auth-notification-actions">
          <button 
            className="auth-notification-btn primary" 
            onClick={() => {
              window.location.href = '/login';
            }}
          >
            Log In Again
          </button>
          {/* <button 
            className="auth-notification-btn secondary" 
            onClick={onDismiss}
          >
            Dismiss
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default AuthNotification; 